import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import React from 'react';
import { portalWithAppContext } from 'components/organisms/app-context/portal-with-context';
import { FeedbackFloatingTrigger as FeedbackFloatingTriggerComponent } from './ui/floating-trigger';

const FeedbackWithTriggerKey = new PluginKey('feedbackWithTrigger');

export const FeedbackWithTrigger = Extension.create({
  name: 'feedbackWithTrigger',
  addOptions() {
    return {
      visible: true,
    };
  },
  addProseMirrorPlugins() {
    const { feedbackData } = this.options?.feedbackPayload ?? {};

    return [
      new Plugin({
        key: FeedbackWithTriggerKey,
        state: {
          init: () => DecorationSet.empty,
          apply: (tr, set) => set.map(tr.mapping, tr.doc),
        },
        props: {
          decorations: (state) => {
            const decorations: Decoration[] = [];
            const doc = state.doc;

            for (let i = 0, pos = 0; i < doc.childCount; i++) {
              const node = doc.child(i);
              // const nodeStart = pos + 1;
              // ProseMirror positions are 1-based for nodeDOM

              pos += node.nodeSize;

              if (
                node.type.name !== 'RL_CUSTOM_SECTION' ||
                !this.options.visible
              ) {
                continue;
              }

              const feedbackNodeData = {
                sourceType: 'DOCUMENT_SECTION',
                sourceId: node.attrs.documentSectionId,
                parentId: this.options?.feedbackPayload.sourceId,
                parentType: this.options?.feedbackPayload.sourceType,
                feedbackData: feedbackData.find(
                  (feedback) =>
                    feedback.sourceId ===
                      parseInt(node.attrs.documentSectionId) &&
                    feedback.sourceType === 'DOCUMENT_SECTION',
                ),
              };

              decorations.push(
                Decoration.widget(
                  pos - 1,
                  () => {
                    const div = document.createElement('div');

                    div.style.display = 'inline-block';
                    div.style.verticalAlign = 'middle';

                    // Get the DOM element for the top-level node
                    // const nodeDOM = view.nodeDOM(nodeStart) as HTMLElement;

                    portalWithAppContext({
                      container: div,
                      children: (
                        <FeedbackFloatingTriggerComponent
                          visible={this.options.visible}
                          feedbackNodeData={feedbackNodeData}

                          // nodeDOM={nodeDOM}
                        />
                      ),
                    });

                    return div;
                  },
                  { side: 1 },
                ),
              );
            }

            return DecorationSet.create(doc, decorations);
          },
        },
      }),
    ];
  },
});
